var _style, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoDataFound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 80.5 80.4",
    style: {
      enableBackground: "new 0 0 80.5 80.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#3A3A3A;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M73.5,2.7c0.6-0.6,1.1-1.2,1.6-1.7c1.2-1.2,3-1.2,4.1,0C80.5,2,80.5,3.7,79.3,5c-1.7,1.7-3.4,3.4-5,5.1 C51.3,32.9,28.4,55.8,5.5,78.7c-0.6,0.6-1.3,1.1-2.1,1.2c-1.2,0.3-2.4-0.4-2.9-1.5c-0.6-1.1-0.4-2.4,0.5-3.3 c1.4-1.4,2.8-2.8,4.2-4.2c0.5-0.5,0.7-0.9,0.7-1.6c0-12.4,0-24.8,0-37.2c0-1.3,0.4-2.3,1.3-3.2c9.2-9.2,18.4-18.4,27.6-27.6 C35.7,0.4,36.7,0,38,0c9.9,0,19.7,0,29.6,0C70,0,72,0.5,73.5,2.7z M11.7,64.4c0.3-0.3,0.6-0.6,0.8-0.8C31,45.2,49.4,26.7,67.9,8.3 c0.7-0.7,1-1.5,0.7-2.5c-9.5,0-19,0-28.5,0c0,0.4,0,0.8,0,1.1c0,7.1,0,14.3,0,21.4c0,3.6-2.4,6-6,6c-7.2,0-14.3,0-21.5,0 c-0.3,0-0.7,0-1,0C11.7,44.4,11.7,54.3,11.7,64.4z M34.4,10.2c-6.1,6.1-12.3,12.3-18.4,18.4c6,0,12.2,0,18.4,0 C34.4,22.3,34.4,16.2,34.4,10.2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M68.7,74.3c0-0.6,0-1.2,0-1.7c0-15.9,0-31.8,0-47.6c0-2.1,1.6-3.4,3.6-3c1.3,0.3,2.1,1.5,2.1,3 c0,8.4,0,16.8,0,25.2c0,8,0,15.9,0,23.9c0,3.5-2.4,5.9-5.9,5.9c-16.4,0-32.7,0-49.1,0c-1.7,0-2.8-1-3.1-2.5c-0.2-1.4,0.6-2.7,2-3.1 c0.4-0.1,0.9-0.1,1.3-0.1c15.7,0,31.5,0,47.2,0C67.5,74.3,68,74.3,68.7,74.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoDataFound);
export default __webpack_public_path__ + "static/media/no-data-found.adda86caf9e82366adbaf8e0aff4e227.svg";
export { ForwardRef as ReactComponent };